import { useEffect, useState } from 'react';
import { AuthGate } from './AuthGate';
import { persistOnboarding } from '../lib/persistOnboarding';

/**
 * Post-checkout landing page.
 * Paddle redirects here after successful payment with ?_ptxn=txn_xxx.
 * Shows AuthGate so the user can create their account.
 */
export function PostCheckout() {
  const [transactionId] = useState(
    () => new URLSearchParams(window.location.search).get('_ptxn')
  );

  useEffect(() => {
    if (!transactionId) {
      window.location.href = '/';
      return;
    }
    // Save transaction for linking after signup (preserve customerId if already set by paddle.ts)
    const existing = sessionStorage.getItem('atilum_paddle');
    const parsed = existing ? JSON.parse(existing) : {};
    sessionStorage.setItem('atilum_paddle', JSON.stringify({ ...parsed, transactionId }));
  }, [transactionId]);

  if (!transactionId) return null;

  return (
    <div className="min-h-screen bg-stone-50 flex items-center justify-center">
      <AuthGate
        onClose={() => { window.location.href = '/'; }}
        initialMode="signup"
        allowModeSwitch={true}
        onSignUpSuccess={persistOnboarding}
      />
    </div>
  );
}
